import styled, { css } from 'styled-components';
import { rem, em, transparentize } from 'polished';
import { Button } from 'elements';
import { colors, isDefaultThemeMode } from 'core/theme';
import { media } from 'core/layout';

export const StyledPopup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
  background-color: ${colors.B87A};
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;

  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  ${media.tabletSmall`
    height: 100;

    & > div {
      padding: 0;
    }
  `};
`;

export const CloseButton = styled(Button) `
  color: ${colors.secondary};
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(1.5em, -1.5em);

  ${media.site`
    margin: 0.35em;
    transform: none;
  `};
`;


export const StyledGalerija = styled.div`
  display: flex;
  height: 100%;
  max-height: 667px;

  & > section {
    background-color: ${colors.black};
    flex-basis: ${(3/4) * 100}%;
    padding: 6em 4em;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    & > div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      @media (min-height: 600px) {
        min-height: 400px;

        & > iframe {
          min-height: 400px;
        }
      }
    }
  }

  & > aside {
    background-color: ${colors.background};
    flex-basis: ${(1/4) * 100}%;
    padding: 1.5em;

    ${props => !isDefaultThemeMode(props) && css`
      border: 1px solid ${colors.text};
    `};

    & > div {
      position: relative;
      height: 100%;

      & > div {
        height: calc(100% - 1rem);
        overflow-y: auto;

        ${media.site`
          overflow-y: visible;
        `};
      }

      & > span {
        color: ${colors.lightText};
        font-size: ${em(14)};
      }

      & > p {
        margin-bottom: 0 !important;

        ${media.site`
          margin-bottom: 1.5rem !important;
        `};
      }
    }
  }

  ${media.site`
    flex-direction: column;
    position: relative;

    & > section,
    & > aside {
      flex-basis: auto;
      width: 100%;
    }

    & > section {
      flex: 1 1 auto;
      align-items: center;
      padding: 3em 2em 1em;

      & > div {
        width: 100%;
      }
    }

    & > aside {
      flex: 0 0 auto;
      font-size: ${em(14)};
      padding: 1em;

      height: 30%;
      overflow-y: auto;

      & > div {
        position: static;

        & > p {
          margin-top: 0.5em !important;
        }

        & > p:empty {
          margin-top: 0 !important;
        }
      }
    }
  `};

  @media screen and (max-height: 400px) {
    & > section {
      flex-basis: 100%;
      align-items: center;
      padding: 1em;

      & > div {
        width: 100%;
      }
    }

    & > aside {
      display: none;
    }
  }
`;

export const ImgWrapper = styled.div`
  display: flex;
  align-items: center;

  & > img {
    width: 100%;
  }
`;

export const ButtonNext = styled(Button) `
  border-radius: 50% !important;
  width: ${rem(58)};
  height: ${rem(58)};

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  & > span {
    padding: 0;
    padding-left: 0.2em;
  }

  svg {
    color: ${colors.background};
    width: 2rem;
    height: 2rem;
  }

  background-color: ${props => transparentize(0.5, colors.primary(props))} !important;

  &:hover {
    background-color: ${colors.primary} !important;
  }
  &:active {
    background-color: ${colors.primary} !important;
  }

  ${media.site`
    width: ${rem(40)};
    height: ${rem(40)};

    svg {
      width: 1rem;
      height: 1rem;
    }
  `};
`;

export const ButtonPrev = ButtonNext.extend`
  transform: scaleX(-1) !important;
`;

export const StyledContent = styled.div`
    font-size: ${16/18}rem;

    & > div > p {
      padding-right: 24px;

      &:first-child {
        margin-top: 0 !important;
      }

      &:last-child {
        margin-bottom: 0 !important;
      }
    }

    ${media.site`
      & > div {
        margin-bottom: 1.5rem;
      }
    `};
`;

export const DownloadLink = styled.a`
  display: inline-block;
  padding: 0.5em;
  text-decoration: none;

  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  right: 0;
  bottom: 0;
  transform: translateY(1rem);

  background-color: ${props => isDefaultThemeMode(props) ? transparentize(0.5, colors.primary(props)) : transparentize(0.5, colors.text(props))};

  svg {
    color: ${colors.background};
  }

  &:hover {
    background-color: ${props => isDefaultThemeMode(props) ? colors.primary : colors.text};
  }

  ${media.site`
    transform: translateY(0);
  `};
`



// WEBPACK FOOTER //
// ./src/pages/Sakums/components/GalleryPopup/styled.js